import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function AdminPage() {
  const [fname, setfname] = useState("");
  const [sname, setsname] = useState("");
  const [age, setage] = useState("");
  const [height, setheight] = useState("");
  const [ethnicity, setethnicity] = useState("");
  const [disability, setdisability] = useState(false);
  const [visitor, setvisitor] = useState(false);
  const [sex, setsex] = useState("");
  const [street, setstreet] = useState("");
  const [house_num, sethousenum] = useState("");
  const [post, setpost] = useState("");
  const [city, setcity] = useState("");
  const [phone, setphone] = useState("");
  const [emergencyName, setemergencyName] = useState("");
  const [emergencyNumber, setemergencyNumber] = useState("");
  
  const navigate = useNavigate();
  const HandleHome = (event) => {
    event.preventDefault();
    navigate('/adminpage'); 
  };
  const SearchPerson = (event) => {
    event.preventDefault();
    navigate('/searchPerson'); 
  };
  const StartEvac = (event) => {
    event.preventDefault();
    navigate('/start'); 
  };

  const HandleAddPerson = (event) => {
    event.preventDefault();
    navigate('/addPersonOption');
  };

  const HandleAddPersonTemp = (event) => {
    event.preventDefault();
    navigate('/addPersonTemp');
  };

  const HandleAddPersonPerm = (event) => {
    event.preventDefault();
    navigate('/addPerson');
  };

  const RemovePerson = (event) => {
    event.preventDefault();
    navigate('/removePersonOption'); 
  };
  const ModifyPerson = (event) => {
    event.preventDefault();
    navigate('/modify'); 
  };
  const emergencyPlan = (event) => {
    event.preventDefault();
    navigate('/emergencyPlan'); 
  };

  const Visitor_Checkbox = async (event) => {
    const checkbox = event.target;
    if (checkbox.checked) {
      setvisitor(true);
    } else {
      setvisitor(false);
    }
  }

  const apiUrl = "https://48i7x4lcza.execute-api.eu-west-2.amazonaws.com/default/addPersonLambda";

  const Disability_Checkbox = async (event) => {
    const checkbox = event.target;
    if (checkbox.checked) {
      setdisability(true);
    } else {
      setdisability(false);
    }
  }
  
  const addPersontoDatabase = async (event) => {
    event.preventDefault();
    try {
      const userData = {
        fname: fname,
        sname: sname,
        age: age,
        height: height,
        ethnicity: ethnicity,
        sex: sex,
        disability: disability,
        visitor: visitor,
        phone: phone,
        city: city,
        house_num: house_num,
        post: post,
        street: street,
        emergencyName: emergencyName,
        emergencyNumber: emergencyNumber,
      };

      console.log(userData);

      const response = await axios.post(apiUrl, userData);
      console.log('Data sent to API:', response.data);
      navigate('/addedPerson');
    } catch (error) {
      console.error('Error sending data to API:', error);
      alert('Failed to add person!');
    }
  };

  return (
    <Container className= "main-page-content">
      <Row>
        <Col>
          <img className="app-logo" src={Logo} width="400" height="50" alt="SmartEvac Logo" />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <h3>Add Person</h3>
          <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link href="#home" onClick={HandleHome}>Home</Nav.Link>
                  <Nav.Link href="#link"onClick={SearchPerson} >Search</Nav.Link>
                  <Nav.Link href="#link" onClick={HandleAddPerson}>Add</Nav.Link>
                  <Nav.Link href="#link" onClick={RemovePerson}>Remove</Nav.Link>
                  <Nav.Link href="#link" onClick={ModifyPerson}>Modify</Nav.Link>
                  <Nav.Link href="#link" onClick={emergencyPlan}>Plan</Nav.Link>
                </Nav>
                <Nav className="ms-auto">
                  <Nav.Link href="#link" onClick={StartEvac}>Start Evacuation</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </Col>
      </Row>
      <br></br>
      <Row className="justify-content-center">
        <Col xs={12} sm={8} md={6} lg={5}>
          <form className="loginForm" onSubmit={addPersontoDatabase}>
            <p className="Title">Person details</p>
            
            <Row>
            
              <Col xs={12} md={6}>
                <div className="form-group">
                  <input type="text" name="fname" placeholder="Forename" onChange={(e) => setfname(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="text" name="sname" placeholder="Surname" onChange={(e) => setsname(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="date" name="age" placeholder="Age" onChange={(e) => setage(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="text" id="city" name="city" placeholder="City" onChange={(e) => setcity(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="text" id="house_num" name="house_num" placeholder="House/ Flat number" onChange={(e) => sethousenum(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="tel" id="phone" name="phone" placeholder="Phone Number" onChange={(e) => setphone(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="text" id="emergency_contact" name="emergency_contact" placeholder="Emergency Contact Name" onChange={(e) => setemergencyName(e.target.value)} required />
                </div>
              </Col>

             
              <Col xs={12} md={6}>
                <div className="form-group">
                  <input type="number" id="height" name="height" placeholder="Height (cm)" onChange={(e) => setheight(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="text" id="ethnicity" name="ethnicity" placeholder="Ethnicity" onChange={(e) => setethnicity(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="text" id="sex" name="sex" placeholder="Sex" onChange={(e) => setsex(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="text" id="street" name="street" placeholder="Street" onChange={(e) => setstreet(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="text" id="postcode" name="postcode" placeholder="Postcode" onChange={(e) => setpost(e.target.value)} required />
                </div>
                <div className="form-group">
                  <input type="tel" id="Emergphone" name="Emergphone" placeholder="Emergency Contact Phone Number" onChange={(e) => setemergencyNumber(e.target.value)} required />
                </div>
              </Col>
            </Row>     
            <Row>
              <Col xs={12} md={6}>
                <div className="form-group">
                  <label className="checkbox-label">
                    <input type="checkbox" className="checkbox" onClick ={Disability_Checkbox} />
                    <span className="checkbox-text">Disabled</span>
                  </label>
                </div>
              </Col>
            </Row>    
            <Row>
              <Col xs={12} md={6}>
                <div className="form-group">
                  <label className="checkbox-label">
                    <input type="checkbox" className="checkbox" onClick ={Visitor_Checkbox} />
                    <span className="checkbox-text">Visitor</span>
                  </label>
                </div>
              </Col>
            </Row>  
            <button type="submit" className="login-button">Register</button>
          </form>

        </Col>
      </Row>

    </Container>
  );
}

export default AdminPage;
